import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocument = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 75,
	height: 75,
	viewBox: "0 0 75 75",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 75,
		height: 75,
		rx: 37.5,
		fill: "#DFF1FA"
	}), /* @__PURE__ */ _jsxs("g", {
		transform: "translate(24, 21) scale(2.3)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M2 4V12C2 12.9428 2 13.4142 2.29289 13.7071C2.58579 14 3.05719 14 4 14H8.30769C9.2505 14 9.72191 14 10.0148 13.7071C10.3077 13.4142 10.3077 12.9428 10.3077 12V5.53519C10.3077 5.11819 10.3077 4.9097 10.2288 4.72299C10.1498 4.53629 10.0003 4.39103 9.70114 4.1005L9.70113 4.1005L8.12051 2.56531L8.1205 2.56531C7.83318 2.28624 7.68951 2.14671 7.5087 2.07335C7.32789 2 7.12762 2 6.72707 2H4C3.05719 2 2.58579 2 2.29289 2.29289C2 2.58579 2 3.05719 2 4Z",
				stroke: "#424242",
				strokeWidth: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.53857 2.46191V3.23115C7.53857 4.17395 7.53857 4.64536 7.83147 4.93825C8.12436 5.23114 8.59577 5.23114 9.53857 5.23114H10.3078",
				stroke: "#424242",
				strokeWidth: .8
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.30762 11.692H7.07685M4.30762 8.46124H8.923M4.30762 5.23047H5.69223",
				stroke: "#424242",
				strokeWidth: .8,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})]
});
export default SvgDocument;
